import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiKey } from "../config/config";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function AddBranchUser({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || 'null')?.admin ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token : null;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    customer_name: "",
    contact_number: "",
    email: "",
    valid_id_number: "",
    role: "staff",
    password: "",
  });

  const [branchId, setBranchId] = useState();

  useEffect(() => {
    const admin = JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin);
    setBranchId(admin.branch_id);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!branchId) {
      toast.error("Branch ID not found");
      return;
    }

    axios
      .post(
        apiKey + "/add-branch-user",
        {
          ...formData,
          branch_id: branchId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        toast.success(res.data.Message || "User created successfully", {
          onClose: () => navigate("/dashboard/branch-users"),
        });
      })
      .catch((err) => {
        console.error(err);
        const errorMsg = err.response?.data?.Error || "Failed to create user";
        toast.error(errorMsg);
      });
  };

  return (
    <main id="main" className="main">
      <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="pagetitle">
        <h1>{lang.Add_User || "Add User"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Users || "Users"}</li>
            <li className="breadcrumb-item active">{lang.Add_User || "Add User"}</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{lang.User_Information || "User Information"}</h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">{lang.Name || "Name"} *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="customer_name"
                        value={formData.customer_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">{lang.Email || "Email"} *</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">{lang.Phone_Number || "Phone Number"} *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="contact_number"
                        value={formData.contact_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">{lang.Identity_Number || "Identity Number"} *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="valid_id_number"
                        value={formData.valid_id_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">{lang.City || "City"}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">{lang.Address || "Address"}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>
                  </div> */}

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">{lang.Role || "Role"} *</label>
                      <select
                        className="form-select"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        required
                      >
                        <option value="staff">Staff</option>
                        <option value="manager">Manager</option>
                        <option value="dealer">Admin</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">{lang.Password || "Password"} *</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        minLength={6}
                      />
                    </div>
                  </div>

                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => navigate(-1)}
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {lang.Save || "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AddBranchUser;